import { existsSync } from "node:fs";
import { join, relative, dirname } from "node:path";
import type { ComponentIR } from "../ir.js";
import type { GeneratedFile, GenerateOptions, Generator } from "./types.js";
import { operationTypeNames } from "./schema-to-ts.js";

function typesImportPath(handlerPath: string): string {
  const handlerDir = dirname(handlerPath);
  const rel = relative(handlerDir, "generated/component.types");
  const importPath = rel.startsWith(".") ? rel : `./${rel}`;
  return `${importPath}.js`;
}

function buildHandlerSkeleton(
  operationName: string,
  functionName: string,
  handlerPath: string,
): string {
  const names = operationTypeNames(operationName);
  const typesImport = typesImportPath(handlerPath);

  return `/** Handler skeleton — implement the logic below. */
/* eslint-disable */

import type { ${names.input}, ${names.output} } from "${typesImport}";

export async function ${functionName}(
  input: ${names.input},
): Promise<${names.output}> {
  // TODO: implement
  throw new Error("Not implemented: ${functionName}");
}
`;
}

export const handlerGenerator: Generator = {
  generate(ir: ComponentIR, options: GenerateOptions): GeneratedFile[] {
    const files: GeneratedFile[] = [];

    for (const [operationName, op] of Object.entries(ir.operations)) {
      if (!op.handler) {
        continue;
      }

      const functionName = op.handler;
      const handlerPath = `./handlers/${functionName}.ts`;
      const absPath = join(options.outputDir, handlerPath);
      if (existsSync(absPath)) {
        files.push({
          path: handlerPath,
          content: "",
          overwrite: false,
          warning: `Handler file already exists, skipping: ${handlerPath}`,
        });
        continue;
      }

      files.push({
        path: handlerPath,
        content: buildHandlerSkeleton(operationName, functionName, handlerPath),
        overwrite: false,
      });
    }

    return files;
  },
};
